import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const chatBranchPickerDefaultVariants = {}
const chatBranchPickerCompoundVariants = []

const chatBranchPickerSlotNames = [
  [
    "root",
    "chatBranchPicker__root"
  ]
]
const chatBranchPickerSlotFns = /* @__PURE__ */ chatBranchPickerSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, chatBranchPickerDefaultVariants, getSlotCompoundVariant(chatBranchPickerCompoundVariants, slotName))])

const chatBranchPickerFn = memo((props = {}) => {
  return Object.fromEntries(chatBranchPickerSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const chatBranchPickerVariantKeys = []
const getVariantProps = (variants) => ({ ...chatBranchPickerDefaultVariants, ...compact(variants) })

export const chatBranchPicker = /* @__PURE__ */ Object.assign(chatBranchPickerFn, {
  __recipe__: false,
  __name__: 'chatBranchPicker',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: chatBranchPickerVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, chatBranchPickerVariantKeys)
  },
  getVariantProps
})